<h4 mat-dialog-title>Rollback Result</h4>
<mat-dialog-content>
<table>
    <tr class="heading">
    <td>Entity Name</td>
    <td>Action</td>
      <td>Message</td>
       <td *ngIf="this.ActionValue=='Update'">Success List</td>
         <td *ngIf="this.ActionValue=='Update'">Failed List</td>
    </tr>

<tr *ngFor="let item of data" class="content">
    <td>{{ item.name}}</td>
    <td>{{item.action}}</td>
    <td>{{item.message}}</td>
     <td *ngIf="this.ActionValue=='Update'"> <div *ngFor="let success of item?.successList">
      {{ success }}
    </div></td>
     <td *ngIf="this.ActionValue=='Update'">
         <div *ngFor="let failed of item?.failedList">
      {{failed}}
    </div>
     </td>
</tr>
</table>
</mat-dialog-content>

   <mat-dialog-actions class="modal-footer" align="end">
      <div class="action-bar" >
        <button class="btn-create" style="color: white;margin-left: 15px;"  (click)="closeDialog()">Ok</button>
    </div>
    </mat-dialog-actions>
